import React from "react";
import Modal from "./Modal";

import { MODAL_CLOSE } from "src/constants/images";

const CheckUnSyncWalletModal = ({ isVisible, onClick }) => {
  return (
    <Modal
      isVisible={isVisible}
      overlayClass="overlay"
      className="disconnect-modal card px-3 py-3"
    >
      <span
        onClick={() => onClick()}
        onKeyPress={(e) => e.code == "Enter" && onClick()}
        className="close-modal"
      >
        <img src={MODAL_CLOSE.SOURCE} alt="close" />
      </span>
      <div className="heading">
        <h4 className="mb-2">Alert!</h4>
        <p className="text my-3">
          Your gangster is being minted. Please refresh your screen in a few
          seconds to see your Gangster
        </p>
      </div>
      <div className="body">
        <button className="btn btn-outline-primary profile" onClick={onClick}>
          Close
        </button>
      </div>
    </Modal>
  );
};

export default CheckUnSyncWalletModal;
